module.exports = __webpack_public_path__ + "static/media/Jen-Walker.88124177.jpg";